module.exports = __webpack_public_path__ + "img/two_4.423beb88.png";